module.exports = __webpack_public_path__ + "img/PT-ES.ca14302.png";